import { render, staticRenderFns } from "./ambulanceProfileSummaryDetails.vue?vue&type=template&id=44b42aa6&"
import script from "./ambulanceProfileSummaryDetails.vue?vue&type=script&lang=js&"
export * from "./ambulanceProfileSummaryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VBtn,VChip})
